import services from "@/http";
import * as types from "./mutation-types";
import * as storage from "../storage";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetCategorias", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  var categorias = {
    data: [],
    meta: {},
  };

  await services.categorias.get_all(search).then((res) => {
    categorias = res.data;
  });
  return categorias;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.categorias.show({ id: id }).then((res) => {
    dispatch("ActionSetCategoria", res.data.categoria);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.categorias.store(payload).then((res) => {
    commit(types.SET_CATEGORIA, res.data.categoria);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.categorias.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_CATEGORIA, res.data.categoria);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.categorias.delete({ id: id }).then(() => {
    commit(types.SET_CATEGORIA, null);
  });
};

export const ActionSetCategorias = ({ commit }, payload) => {
  commit(types.SET_CATEGORIAS, payload);
};

export const ActionSetCategoria = ({ commit }, payload) => {
  commit(types.SET_CATEGORIA, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewCategoria = ({ commit }) => {
  commit(types.SET_CATEGORIA, {});
};

export const ActionToSelect = async ({ dispatch }, id) => {
  let response = storage.getCategoriaToSelect();
  if (!response || !response.length) {
    await services.categorias.to_select({ id: id }).then((res) => {
      response = res.data;
      storage.setCategoriaToSelect(response);
    });
  }
  return response;
};
